<template>
  <DataProvider :endpoint='mountUrlAndParams(endpoint).url' :filter='mountUrlAndParamsFilter(endpoint).filter' ref='dataProvider'>
    <div slot-scope='{ data: response, loading }'>
      <Table
        v-if='response && response.data'
        :data='response && response.data'
        ref='dataTable'
        :title="$t('curatorship.searchResult')"
        :customTotal='(response && response.total) || 0'
        @pagination='handlePagination'
        @click-row='openDialog'
        :currentSort.sync='filter.orderBy'
        :currentSortOrder.sync='filter.order'
        :selectable='false'
        :loading='loading'
        customHeader
        :endpoint='mountUrlAndParams(endpoint).url'
        :filter='mountUrlAndParamsFilter(endpoint).filter'
        :labels='labels'
        :chartLabels='chartLabels'
        :formatLabelFunction='formatLabelsWithFiles'
        :menuValue.sync='menuValue'
        :createHeader='createHeaderPDF'
        :answerValue.sync='answerValue'
        @search-query='handleSearch'
        @close-table='closeTable'
      >
        <template slot='footer' slot-scope='{ pagination }'>
          <v-row style='justify-content: flex-end;'>
            <v-col cols='auto'>
              <md-field>
                <label for='pages'>
                  {{ $t('assistantsList.perPage') }}
                </label>
                <md-select v-model='pagination.perPage' name='pages' >
                  <md-option
                    v-for='item in pagination.perPageOptions'
                    :key='item'
                    :label='item'
                    :value='item'
                  >
                    {{ item }}
                  </md-option>
                </md-select>
              </md-field>
            </v-col>
          </v-row>
        </template>
        <template slot='cells' slot-scope='{ item }'>
          <!-- start -->
          <md-table-cell
            :md-label='labels[0]'
            md-sort-by='process_time'
          > {{ formatLabels(item, 0) }}
          </md-table-cell>

          <!-- send to -->
          <!-- eslint-disable-next-line vue/no-v-text-v-html-on-component  -->
          <md-table-cell :md-label='labels[1]' style='display: table-cell;' v-html='formatLabels(item, 1)'/>

          <!-- cpf -->
          <!-- eslint-disable-next-line vue/no-v-text-v-html-on-component  -->
          <md-table-cell :md-label='labels[2]' style='display: table-cell;' v-html='formatLabels(item, 2)'/>

          <!-- answer to question -->
          <!-- eslint-disable-next-line vue/no-v-text-v-html-on-component  -->
          <md-table-cell :md-label='labels[3]' style='display: table-cell;' v-html='formatLabels(item, 3)'/>

          <!-- return message -->
          <!-- eslint-disable-next-line vue/no-v-text-v-html-on-component  -->
          <md-table-cell :md-label='labels[4]' style='display: table-cell;' v-html='formatLabels(item, 4)'/>
        </template>
      </Table>
      <v-dialog v-model='dialog' max-width='700px' scrollable persistent>
        <ChatConversation
          :chatLoader='chatLoader'
          :chatData='chatData'
          :chatInfo='chatInfo'
          :channelConfig='channelConfig'
          :key='chatInfo._id'
          :idConversationAnalysisPerDeliveredService='idConversation'
          @close='closeDialog'
        />
      </v-dialog>
    </div>
  </DataProvider>
</template>

<script>
import Pagination from '@/components/Pagination.vue'
import chatsList from '@/pages/data/chatsList'
import DateInterval from '@/components/DateInterval.vue'
import Table from '@/components/CuratorshipUserFeedbackByItem/Table.vue'
import DataProvider from '@/components/DataProvider'
import ChatConversation from '@/components/ChatConversation'
import { mapFields } from 'vuex-map-fields'
import * as moment from 'moment'
import { mask } from 'vue-the-mask'
import { selectedLocale } from '@/plugins/i18n'

export default {
  directives: { mask },
  data () {
    return {
      search: null,
      labels: [
        this.$t('search.start'),
        this.$t('search.sentBy'),
        this.$t('search.cpfCitizen'),
        this.$t('search.returnQuestion'),
        this.$t('search.message')
      ],
      data: this.response,
      dialog: false,
      chatLoader: false,
      showFilter: true,
      filter: {
        order: 'desc',
        orderBy: 'request_datetime',
        page: 0,
        perPage: null,
        by: null,
        search: null,
        answer: null,
        services: null
      },
      tableData: chatsList,
      searchedData: [],
      chatData: {},
      chatInfo: {},
      idConversation: '',
      channelConfig: null,
      menuValue: [...this.preSelectedMenuFilter],
      answerValue: [],
      dateFromReceived: '',
      dateToReceived: ''
    }
  },
  props: {
    title: {
      type: String
    },
    preSelectedMenuFilter: {
      type: Array
    },
    preSelectedAnswerFilter: {
      type: Array
    },
    chartLabels: {
      type: Array
    },
    endpoint: {
      type: String
    }
  },
  components: {
    // eslint-disable-next-line vue/no-unused-components
    Pagination,
    // eslint-disable-next-line vue/no-unused-components
    DateInterval,
    Table,
    DataProvider,
    ChatConversation
  },
  created () {
    this.answerValue = this.preSelectedAnswerFilter
    this.dateFromReceived = this.dateInterval.timestamp1
    this.dateToReceived = this.dateInterval.timestamp2
  },
  watch: {
    preSelectedMenuFilter (value) {
      this.menuValue = value
    },
    preSelectedAnswerFilter (value) {
      this.answerValue = value
    },
    DateInterval: {
      handler (nV) {
        this.updatedDate()
      }
    },
    Filter: {
      deep: true,
      handler (nV) {
        this.searchOptions(nV)
      }
    }
  },
  computed: {
    ...mapFields('analysisPerServiceDeliveredFilter', ['citizensCPF', 'service', 'returnCode']),
    ...mapFields('reports', ['dateInterval'])
  },
  methods: {
    upFirstLetter (word) {
      if (word) {
        const wordValue = word
        let wordFormatted = ''
        if (wordValue.includes("<span class='highlight'>sim</span>")) {
          wordFormatted = "<span class='highlight'>Sim</span>"
        } else if (wordValue.includes("<span class='highlight'>não</span>")) {
          wordFormatted = "<span class='highlight'>Não</span>"
        } else {
          wordFormatted = wordValue.charAt(0).toUpperCase() + wordValue.slice(1)
        }
        return wordFormatted
      } else {
        return ''
      }
    },

    /* -------------------
      Get Api and filters
    ---------------------- */
    mountUrlAndParams (endpoint) {
      return {
        url: `${process.env.VUE_APP_REPORTS_BACKEND}/reports/${endpoint}`
      }
    },
    mountUrlAndParamsFilter (endpoint) {
      const from = this.dateInterval.timestamp1
      const fromFormatted = moment(from).format('YYYY-MM-DD[T]HH:mm:ss')
      const to = this.dateInterval.timestamp2
      const toFormatted = moment(to).format('YYYY-MM-DD[T]HH:mm:ss')
      const answer = (this.answerValue.includes('sim') && this.answerValue.includes('não')) ? undefined : this.answerValue[0]

      if (this.dateFromReceived !== from || this.dateToReceived !== to) {
        this.closeTable()
      }

      return {
        url: `${process.env.VUE_APP_REPORTS_BACKEND}/reports/${endpoint}`,
        filter: {
          to: toFormatted,
          from: fromFormatted,
          order: this.filter.order,
          orderBy: 'request_datetime',
          page: this.filter.page,
          perPage: this.filter.perPage,
          requester: this.filter.requester || undefined,
          services: this.filter.services || undefined,
          status: this.filter.status || undefined,
          answer,
          search: this.filter.search || undefined,
          menu: this.menuValue.join(',')
        }
      }
    },

    /* --------------
      Buttons filter
    ---------------- */
    mappingOptions (value) {
      let result = []
      value.split(',').map((item) => {
        switch (item) {
          case 'All':
          case 'Todos':
            result.push()
            break
          case 'Sí':
          case 'Yes':
          case 'Sim':
            result.push('sim')
            break
          case 'No':
          case 'Não':
            result.push('não')
            break
          default:
            break
        }
      })
      return result.toString()
    },

    searchOptions (nV) {
      if (nV?.length > 0) {
        this.$set(this.filter, 'answer', this.mappingOptions(nV.toString()))
      } else {
        this.$delete(this.filter, 'answer')
      }
    },

    handleSearch (searchText) {
      if (searchText) {
        this.$set(this.filter, 'search', searchText)
      } else {
        this.$delete(this.filter, 'search')
      }
    },

    changeFilters () {
      let newFilter = { ...this.filter }
      newFilter = {
        ...this.filter,
        search: this.filter.search,
        service: this.filter.service,
        answer: this.filter.answer
      }
      this.filter = { ...newFilter }
      this.$nextTick(() => {
        this.$refs.dataProvider.load()
      }, 1000)
    },

    toggleShowFilter () {
      this.showFilter = !this.showFilter
    },

    /* -----------
      Pagination
    -------------- */
    handlePagination (pagination, oldPagination) {
      const newFilter = {}
      const { currentPage, perPage } = pagination
      if (currentPage && this.filter.page !== currentPage - 1) {
        newFilter.page = currentPage - 1
      }
      if (perPage && this.filter.perPage !== perPage) {
        newFilter.perPage = perPage
      }
      Object.assign(this.filter, newFilter)
    },

    /* -------------------
      Card info por row
    ---------------------- */
    async openDialog (rowProps) {
      // eslint-disable-next-line camelcase
      const conversationId = rowProps.item?._source.conversation_id
      this.dialog = true
      this.chatLoader = true
      try {
        const result = await this.$axios.get(`${process.env.VUE_APP_REPORTS_BACKEND}/interactions`, {
          params: {
            page: 0,
            perPage: 1000,
            conversationId: conversationId,
            event: 'search-interactions'
          }
        })
        this.chatData = result.data
        let newChatInfo = {
          _id: conversationId,
          _source: {}
        }
        this.chatInfo = result.data.parent ? result.data.parent : newChatInfo
      } catch (error) {
      }
      this.chatLoader = false
    },
    closeDialog () {
      this.dialog = false
    },

    /* -----------------------
      Date and hour formatted
    -------------------------- */
    updatedDate () {
      const from = this.dateInterval.timestamp1
      const fromFormatted = moment(from).format('YYYY-MM-DDTHH:mm:ss')
      const to = this.dateInterval.timestamp2
      const toFormatted = moment(to).format('YYYY-MM-DDTHH:mm:ss')
      this.filter.from = fromFormatted
      this.filter.to = toFormatted
      this.$refs.dataProvider.load()
    },

    formatDate (item, type) {
      let date = item[type]
      return moment(date).locale(selectedLocale).format('L LT')
    },

    leadZeros (pad, number) {
      return String(number).padStart(pad, '0')
    },

    checkIfFormatDuration (item) {
      return item._source.total_duration ? this.fomartDuration(item._source.total_duration) : '-'
    },

    fomartDuration (duration) {
      let minutes, seconds
      if (duration >= 1) {
        minutes = Math.floor(duration)
      }
      const fractionOfSeconds = Math.ceil(duration) - duration
      seconds = Math.round(fractionOfSeconds * 60)
      return `${minutes ? minutes + 'min' : ''}${seconds ? seconds + 's' : ''}`
    },

    /* -------------------------
      Labels and info's table
    ---------------------------- */
    formatLabels (item, i) {
      // eslint-disable-next-line camelcase
      if (this.endpoint === 'userFeedbackByItem' || this.endpoint === 'userFeedbackBySubtopic' || this.endpoint === 'userFeedbackByKnowledge') {
        return this.formatUserFeedbackByItemLabel(item, i)
      }
      if (this.endpoint === 'userFeedback') {
        return this.formatUserFeedbackLabel(item, i)
      }
    },
    formatUserFeedbackByItemLabel (item, i) {
      switch (i) {
        // start
        case 0:
          return this.formatDate(item._source, 'request_datetime')
        // sent to
        case 1:
          return item.highlight?.session_nome
            ? this.upFirstLetter(item.highlight?.session_nome[0])
            : this.upFirstLetter(item._source.session_nome)
        // cpfUser
        case 2:
          return item.highlight?.session_cpf
            ? item.highlight?.session_cpf[0]
            : item._source.session_cpf
        // answer to question
        case 3:
          return item.highlight?.information_was_useful
            ? this.upFirstLetter(item.highlight?.information_was_useful[0])
            : this.upFirstLetter(item._source.information_was_useful)
        // return message
        case 4:
          return item.highlight?.answer_button_name
            ? item.highlight?.answer_button_name[0]
            : item._source.answer_button_name
        default:
          break
      }
    },
    formatUserFeedbackLabel (item, i) {
      switch (i) {
        // start
        case 0:
          return this.formatDate(item._source, 'request_datetime')
        // sent to
        case 1:
          return item.highlight?.sender_name_of_input_text
            ? this.upFirstLetter(item.highlight?.sender_name_of_input_text[0])
            : this.upFirstLetter(item._source.sender_name_of_input_text)
        // cpf
        case 2:
          return item.highlight?.user_id
            ? item.highlight?.user_id[0]
            : item._source.user_id
        // answer to question
        case 3:
          return item.highlight?.efficiency_evaluation
            ? this.upFirstLetter(item.highlight?.efficiency_evaluation[0])
            : this.upFirstLetter(item._source.efficiency_evaluation)
        // return message
        case 4:
          return item.highlight?.input_text
            ? item.highlight?.input_text[0]
            : item._source.input_text
        default:
          break
      }
    },
    /* ----------------
      PDFs and files
    ------------------- */
    formatLabelsWithFiles (item, i) {
      if (this.endpoint === 'userFeedbackByItem' || this.endpoint === 'userFeedbackBySubtopic') {
        return this.formatUserByFeedbackItemAndSubtopicFileLabels(item, i)
      }
      if (this.endpoint === 'userFeedback') {
        return this.formatUserFeedbackFileLabels(item, i)
      }
    },
    formatUserByFeedbackItemAndSubtopicFileLabels (item, i) {
      switch (i) {
        // start
        case 0:
          return this.formatDate(item._source, 'request_datetime')
        // sent to
        case 1:
          return this.upFirstLetter(item._source.session_nome)
        // cpfUser
        case 2:
          return item._source.session_cpf
        // answer to question
        case 3:
          return this.upFirstLetter(item._source.information_was_useful)
        // return message
        case 4:
          return item._source.answer_button_name
        default:
          break
      }
    },
    formatUserFeedbackFileLabels (item, i) {
      switch (i) {
        // start
        case 0:
          return this.formatDate(item._source, 'request_datetime')
        // sent to
        case 1:
          return item._source.sender_name_of_input_text
        // cpf
        case 2:
          return item._source.user_id
        // answer to question
        case 3:
          return this.upFirstLetter(item._source.efficiency_evaluation)
        // return message
        case 4:
          return item._source.input_text
        default:
          break
      }
    },
    createHeaderPDF (doc, total) {
      doc.setFontSize(14)
      doc.setFont(undefined, undefined, '700')
      doc.text(15, 10, this.$t('curatorship.searchResults'))

      doc.setFontSize(10)
      doc.setFont('times', undefined, '700')
      doc.text(15, 17, this.$t('search.timeCourse'))
      doc.setFont('times', undefined, '300')

      const from = this.dateInterval.timestamp1
      const to = this.dateInterval.timestamp2
      let formattedDate1 = moment(from).utcOffset(0, true).format('DD/MM/YYYY HH:mm:ss')
      let formattedDate2 = moment(to).utcOffset(0, true).format('DD/MM/YYYY HH:mm:ss')
      doc.text(29, 17, `${formattedDate1} até ${formattedDate2}`)

      doc.setFont('times', undefined, '700')
      doc.text(15, 22, this.$t('search.totalConversations'))
      doc.setFont(undefined, undefined, '300')
      doc.text(46, 22, `${total}`)

      const tableOffsetY = 30
      return tableOffsetY
    },
    closeTable () {
      this.$emit('closeTable')
    }
  }
}
</script>

  <style lang='css'>
  #custom-filter-input > .v-text-field .v-input__control {
    margin: auto;
  }
  </style>
